import { PlotType, StudyManager } from '@/common/plotDefinitions.js'
import store from '@/store'

const PreprocessingOptions=[
  'Crop',
  'Baseline',
  'BPF',
  'BSF',
  'HPF',
  'LPF',
  'Median filter',
  'Moving average',
  'Savitzky-Golay',
	'Flip x',
	'Flip y',
	'Offset x',
	'Offset y',
	'Extrapolate',
	'Accumulate',
	'Differentiate',
	'Outlier Rejection'
]

class studiesCtrl{

  constructor(parent,listSelectionController,type,value = null){
    //Save the references of the lists
    this.listSelectionController=listSelectionController
    this.parent=parent
    this.type=type
    this.options = []
    let indexSelection = -1

    //Try to initialize with the value
    if(value!==null && (value.base in PlotType)){
      indexSelection= store.getters.getStudiesReportViewer.findIndex(currVal=>currVal.configId===value.configId)
      if (indexSelection!==-1){ //If it is not in the list it initialize as a new study
        this.valueSelection = value.base
                this.valueConfigId = value.configId
      }
    }
    if(indexSelection===-1){ //If the index is still a -1 the value was not correct or null
      this.valueSelection = Object.keys(PlotType).filter(study=> PlotType[study].type == this.type)[0]
            this.valueConfigId = StudyManager.getNextConfigId(this.valueSelection)
            const newValue = {
                configId: this.valueConfigId,
                base: this.valueSelection
            }
            store.commit('ADD_STUDIES_ReportViewer', newValue)
    }
        this.updateOptions()
  }

  static createNewStudy(parent,listSelectionController,type){
    const controllerStudy= new studiesCtrl(parent,listSelectionController,type)
    listSelectionController.push(controllerStudy)
  }

  static recoverStudy(parent,listSelectionController,value,type){
    const controllerStudy= new studiesCtrl(parent,listSelectionController,type,value)
    listSelectionController.push(controllerStudy)
  }

  changeSelection(newText,newValue){
    const indexStudy = store.getters.getStudiesReportViewer.findIndex(studyObjt=>studyObjt.configId === this.valueConfigId);
        const elementRemove = {
            index:indexStudy,
            configKey: this.valueConfigId
        }
    this.valueSelection = newValue
    this.valueConfigId = StudyManager.getNextConfigId(this.valueSelection)
    const newObject = {
            configId: this.valueConfigId,
            base: this.valueSelection
        }
        store.commit('DEL_STUDIES_ReportViewer', elementRemove)
        store.commit('ADD_STUDIES_ReportViewer', newObject)
        this.updateOptions()
  }

  updateOptions(){
        this.textSelection = PlotType[this.valueSelection].shortText.replace(this.valueSelection, this.valueConfigId)
        this.options = [{text:this.textSelection, value:this.valueSelection}]
        const availableKeys = Object.keys(PlotType).filter(study=> study !== this.valueSelection && PlotType[study].type == this.type) //Get the available keys of the Type Plot
        availableKeys.forEach(key=> this.options.push({text:PlotType[key].shortText, value:key}) )
        this.disabled= this.options.length===1
  }
}

class preprocesingMultiCtrl{

  constructor(parent,listSelection,listSelectionController,value = null){
    //Save the references of the lists
    this.listSelection=listSelection
    this.listSelectionController=listSelectionController
    this.parent=parent
    this.expanded=true
    this.options = []
    let indexSelection = -1 //Flag for found the value in the list

    //Try to initialize with the value
    if(value!==null && PreprocessingOptions.includes(value)){
      indexSelection= listSelection.findIndex(currVal=>currVal===value)
      if (indexSelection!==-1){ //If it is not in the list it initialize as a new study
        this.valueSelection = value
        this.textSelection = value
        this.updateOptions()
      }
    }

    if(indexSelection===-1){ //If the index is still a -1 the value was not correct or null
      const availableKeys = PreprocessingOptions.filter(study=> !this.listSelection.includes(study)) //Get the available keys of the Type Plot
      availableKeys.forEach(key=> this.options.push({text:key, value:key}) )
      this.valueSelection = this.options[0].value
      this.textSelection = this.options[0].text
      this.listSelection.push(this.valueSelection)
    }
    this.disabled= this.options.length===1
    this.listSelectionController.forEach(controller=>controller.updateOptions())
  }

  static createNewPrepProc(parent,listSelection,listSelectionController){
    const controllerStudy= new preprocesingMultiCtrl(parent,listSelection,listSelectionController)
    listSelectionController.push(controllerStudy)
  }

  static recoverPrepProc(parent,listSelection,listSelectionController,value){
    const controllerStudy= new preprocesingMultiCtrl(parent,listSelection,listSelectionController,value)
    listSelectionController.push(controllerStudy)
  }
    changeSelection(newText,newValue){
    const indexStudy = this.listSelection.findIndex(studyStr=>studyStr === this.valueSelection);
    this.valueSelection = newValue
    this.textSelection = newText
    this.listSelection.push(newValue)
    this.parent.removeElementPreproc(indexStudy, -1)
  }

  updateOptions(){
    this.options = [{text:this.textSelection, value:this.valueSelection}] //Start with it's own value
    const availableKeys = PreprocessingOptions.filter(prepName=> !this.listSelection.includes(prepName)) //Get the available keys of the Type Plot
    availableKeys.forEach(key=> this.options.push({text:key, value:key}) )
    this.disabled= this.options.length===1
  }
}

export {
    studiesCtrl,
    preprocesingMultiCtrl
}
